import $ from "jquery";

export default function presseLoadAjax() {
    function loadPresse(year,month) {
        let loadingSpinner = $('#loading-spinner');
        loadingSpinner.show();
        $('.avu-presse-post-list-container').hide();
        $.ajax({
            type: 'POST',
            url: ajaxurl,
            data: {
                action: 'get_avu_presse',
                selected_post_year: year,
                selected_post_month: month,
            },
            success: function (response) {
                loadingSpinner.hide();
                $('.avu-presse-post-list-container').show();
                $('.avu-presse-post-list-container').html(response);
                $('.avu-presse-template .accordion-button').click(function() {
                    $('.avu-presse-template .accordion-collapse-presse').removeClass('show');
                    $('.avu-presse-template .accordion-button').not(this).addClass('collapsed');
                    let accordionBody = $(this).closest('.accordion-header').next('.accordion-collapse').find('.accordion-body');

                    $('html, body').animate({
                        scrollTop: accordionBody.offset().top - ($(window).height()/2)
                    }, 0);
                });


                    // click image
                    $('.avu-presse-image-single').click(function(){
                        let src = $(this).attr('src');
                        let alt = $(this).attr('alt');
                        $('#img01').attr('src', src);

                        // save image from current accordion
                        currentImages = $(this).closest('.accordion-body').find('.avu-presse-image-single');
                        currentImageIndex = currentImages.index(this);

                        $('#imagePreviewModal').show();
                    });

                    // close Modal
                    $('.close').click(function(){
                        $('#imagePreviewModal').hide();
                    });

                    // image navigation
                    $('.next').click(function(){
                        navigateImage(1);
                    });
                    $('.prev').click(function(){
                        navigateImage(-1);
                    });

                    let currentImages;
                    let currentImageIndex;

                    function navigateImage(direction){
                        currentImageIndex += direction;

                        if(currentImageIndex >= currentImages.length) currentImageIndex = 0;
                        if(currentImageIndex < 0) currentImageIndex = currentImages.length - 1;

                        let newImageSrc = $(currentImages[currentImageIndex]).attr('src');
                        $('#img01').attr('src', newImageSrc);
                    }
            },
            error: function () {
                loadingSpinner.hide();
                $('.avu-presse-post-list-container').html('Keine Pressemitteilung gefunden.');
            }
        });

    }
    $('.avu-press-post-selector').click(function () {
        $('.avu-press-post-selector').removeClass('current');
        $(this).addClass('current');
        let year = $(this).attr('data-post-year');
        let month = $(this).attr('data-post-month');
        loadPresse(year,month);
    });
    loadPresse('all','all');



}